// The BE only accepts condition codes of the form Y + 3 digits, while the codelist holds every document code
const CONDITION_CODE_PATTERN = /^Y\d{3}$/;

const getConditionCodeOptions = <T extends { id: string | number }>(documentTypeOptions: T[] = []): T[] =>
    documentTypeOptions.filter((option) => CONDITION_CODE_PATTERN.test(String(option.id)));

export default getConditionCodeOptions;
